import React from 'react';
import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import MapIcon from '@mui/icons-material/Map';
import TableChartIcon from '@mui/icons-material/TableChart';

const StyledButton = styled(Box)(({ theme, isActive }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '4px',
  backgroundColor: isActive ? '#BD1D23' : '#F8E8E9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  border: '1px solid #E5E9EB',
  padding: '2px',
  '&:hover': {
    backgroundColor: isActive ? '#8B1519' : '#F0F0F0',
    transform: 'scale(1.05)',
  },
}));

const StyledIcon = styled('div')(({ theme, isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: isActive ? '#ffffff' : '#192126',
}));

const FiberPopHeaderButtons = ({ viewType, setViewType, showFilter, setShowFilter }) => {
  const handleFilterClick = () => {
    setShowFilter(!showFilter);
  };

  const handleViewTypeClick = (type) => {
    setViewType(type);
    // Hide filter when switching views
    setShowFilter(false);
  };

  const buttons = [
    {
      name: 'Filter',
      icon: FilterListIcon,
      onClick: handleFilterClick,
      isActive: showFilter,
      show: viewType !== 'table', // Hide filter button in table view
    },
    {
      name: 'Map',
      icon: MapIcon,
      onClick: () => handleViewTypeClick('map'),
      isActive: viewType === 'map',
      show: true,
    },
    {
      name: 'Tabular',
      icon: TableChartIcon,
      onClick: () => handleViewTypeClick('table'),
      isActive: viewType === 'table',
      show: true,
    },
  ];

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '10px',
        right: '32px',
        zIndex: 1000,
        borderRadius: '8px',
        padding: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        mt: '14px',
      }}
    >
      <Grid container spacing={1} justifyContent="center">
        {buttons
          .filter((button) => button.show)
          .map((button) => {
            const IconComponent = button.icon;

            return (
              <Grid item key={button.name}>
                <StyledButton isActive={button.isActive} onClick={button.onClick}>
                  <StyledIcon isActive={button.isActive}>
                    <IconComponent sx={{ fontSize: '24px' }} />
                  </StyledIcon>
                </StyledButton>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default FiberPopHeaderButtons;
